module.exports = __webpack_public_path__ + "media/theme/how-it-works-close-02-2fd3bed6.png";